import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon, CheckIcon } from '@calendly/ui/components/icons';
import { Group, Item, PopupDropdownMenu } from '@calendly/ui/components/menu';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextAction } from '@calendly/ui/theme';
import classNames from 'classnames';
import { sortBy } from 'lodash-es';
import { forwardRef } from 'react';
import { useLazyGetDefaultHolidaysV4Query, useUpdateAvailabilityUserHolidaySetV4Mutation } from '../api';
import { sortHolidays } from './helpers';
import { useCurrentlySupportedCountries } from '../hooks';
const selectContainerCss = "spphnox";
const SelectContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(selectContainerCss, props.className)} />;
});
const controlCss = "c15ntdqh";
const Control = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(controlCss, props.className)} />);
const flexBetweenCss = "f1ahss9b";
const FlexBetween = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(flexBetweenCss, props.className)} />;
});
export const CountryCodeField = ({
  uuid,
  countryCode
}) => {
  const [updateHolidaySet] = useUpdateAvailabilityUserHolidaySetV4Mutation();
  const [triggerGetDefaultHolidays] = useLazyGetDefaultHolidaysV4Query();
  const [toggleDropdown, Dropdown, isDropdownOpen] = useDropdown();
  const {
    supportedCountries
  } = useCurrentlySupportedCountries();
  const country = supportedCountries.find(({
    code
  }) => code === countryCode)?.name;
  const options = sortBy(supportedCountries, 'name').concat([{
    code: 'other',
    name: I18n.t('publisher.account_settings.holidays.countries.other')
  }]).filter(({
    code
  }) => code !== countryCode);
  const onChange = async newCountryCode => {
    const {
      isSuccess,
      data: newHolidays
    } = await triggerGetDefaultHolidays(newCountryCode, true);
    if (isSuccess) {
      updateHolidaySet({
        uuid,
        holidays: sortHolidays(newHolidays),
        redirect: false
      });
    }
  };
  return <div>
      <BodyText size="small" id="country-code-label" htmlFor="country-code">
        {I18n.t('publisher.account_settings.holidays.country_select')}
      </BodyText>
      <SelectContainer>
        <Control id="country-code" aria-labelledby="country-code-label" onClick={toggleDropdown}>
          <BodyText size="large" weight="bold">
            {country || I18n.t('publisher.account_settings.holidays.countries.other')}
          </BodyText>
          {isDropdownOpen ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
        </Control>
        <Dropdown>
          <PopupDropdownMenu>
            <Group>
              <Item>
                <FlexBetween>
                  {country || I18n.t('publisher.account_settings.holidays.countries.other')}
                  <CheckIcon color={colorTextAction} />
                </FlexBetween>
              </Item>
            </Group>
            <Group>
              {options.map(({
              code,
              name
            }) => <Item key={code} onClick={() => onChange(code)}>
                    {name}
                  </Item>)}
            </Group>
          </PopupDropdownMenu>
        </Dropdown>
      </SelectContainer>
    </div>;
};

require("./country_code_field.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./country_code_field.js");